import { cn } from "@/lib/utils";

type TransactionStateProps = {
  extended?: boolean;
  stopped?: boolean;
  className?: string;
};
export const TransactionState = ({ extended, stopped, className }: TransactionStateProps) => {
  if (stopped) {
    return <span className={cn("font-extrabold text-[9px] leading-2.5 text-stopped", className)}>Arrêté</span>;
  }

  if (extended) {
    return (
      <span className={cn("font-extrabold text-[9px] leading-2.5 text-space-available", className)}>Prolongé</span>
    );
  }
  return null;
};
